<script>
    export default {
        props: {
            initDynamicTableId: {
                type: String,
                required: true
            },
            initName: {
                type: String,
                required: true
            },
            initType: {
                type: String,
                required: true
            },
            existingMetadata: {
                type: Array,
                required: true
            },
            connectionTypes: {
                type: Array,
                required: true,
            },
            column: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                dynamicTableId: this.initDynamicTableId,
                connectionTypeId: this.column.metadata_dynamic_table?.connection_type_id ?? this.connectionTypes[0].id,
                columnName: this.initName,
                type: this.initType,
                tablesList: [],
                tablesLoading: false,
                enumOptions: null,
                isShow:false
            };
        },
        mounted() {
            this.loadTables();
        },
        watch: {
            connectionTypeId: function () {
                this.loadTables();
            }
        },
        computed: {
            existedMetadata() {
                return this.existingMetadata.filter(item => {
                    if (parseInt(item.id) === parseInt(this.column.id)) {
                        return false;
                    }

                    return parseInt(item.metadata_dynamic_table_id) === parseInt(this.dynamicTableId) &&
                        item.name === this.columnName;
                })[0];
            },
        },
        methods: {
            loadTables() {
                this.tablesLoading = true;

                axios.get(route('metadata.dynamic-tables.list', {connectionTypeId: this.connectionTypeId})).then(response => {
                    this.tablesList = response.data;
                    this.tablesLoading = false;
                }).catch(() => {this.tablesLoading = false});
            },
            setEnumOptions(data){
                this.enumOptions = data;
                this.isShow = false
            },
            toogleSetting(){
                this.isShow = true
            },
            cancelSetting(){
                this.isShow = false
            }
        }
    };
</script>
